import { NavLink, Outlet } from 'react-router-dom'

import { useAuth } from '../../auth/AuthContext.js'
import { SignOutButton } from '../../components'
import styles from './TeacherLayout.module.css'

export default function TeacherLayout(): JSX.Element {
  const { email } = useAuth()

  return (
    <div className={styles.shell}>
      <aside className={styles.sidebar}>
        <div className={styles.brandBlock}>
          <p className={styles.eyebrow}>Study Decks</p>
          <h1 className={styles.title}>Teacher Console</h1>
          <p className={styles.subtitle}>Author decks. Track engagement.</p>
        </div>
        <nav aria-label="Teacher navigation" className={styles.nav}>
          <ul className={styles.navList}>
            <li>
              <NavLink
                to="/teacher/decks"
                className={({ isActive }) =>
                  [styles.navLink, isActive ? styles.navLinkActive : ''].filter(Boolean).join(' ')
                }
              >
                My decks
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/teacher/classes"
                className={({ isActive }) =>
                  [styles.navLink, isActive ? styles.navLinkActive : ''].filter(Boolean).join(' ')
                }
              >
                My classes
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/teacher/import"
                className={({ isActive }) =>
                  [styles.navLink, isActive ? styles.navLinkActive : ''].filter(Boolean).join(' ')
                }
              >
                Import from Quizlet
              </NavLink>
            </li>
          </ul>
        </nav>
        <div className={styles.sessionCard}>
          <p className={styles.sessionLabel}>Signed in as</p>
          <p className={styles.sessionValue}>{email ?? 'Teacher account'}</p>
          <SignOutButton />
        </div>
      </aside>
      <main id="main-content" className={styles.main}>
        <Outlet />
      </main>
    </div>
  )
}
